import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../shared";
import { Observable } from 'rxjs';
import { SkillHdrContainerModel } from "../../../../../../models/aggregates/alg/bot";
@Injectable({providedIn: "root"})
export class SkillHdrService extends BaseApiTemplateService<SkillHdrContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + 'skills';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + 'skills';
    this.httpClient = http;
  }

  search(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<SkillHdrContainerModel>> {
    let url = this.apiUrl + '/search';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/search' + '?' + pagination.getQueryKeyValues();;
    }
    return this.httpClient.get<PagingResponseModel<SkillHdrContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getElementSkillsGuids(elementGuid: string,  visa: ApiVisa): Observable<ApiResponseModel<string[]>> {
    let url = this.apiUrl + '/element-skills';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/element-skills' + '?';
    }

    const params = new HttpParams()
    .set('elementGuid', elementGuid)

    return this.httpClient.get<ApiResponseModel<string[]>>(
      url,
      {
        ...this.getHttpHeader(visa),
        params
      }
    );
  }

}
